// ITU E.164 dial codes keyed by the `code` values in `./countries.js`. Every
// destination Mytheresa ships to has an entry here so the phone-prefix
// dropdown shows them all. Non-ISO entries (IC, EA, GB-NIR) inherit the dial
// code of their parent country (Spain / UK).
export const DIAL_CODES = {
  AX: '+358', AL: '+355', DZ: '+213', AS: '+1', AD: '+376', AG: '+1',
  AR: '+54', AM: '+374', AU: '+61', AT: '+43', AZ: '+994', BS: '+1',
  BH: '+973', BD: '+880', BB: '+1', BE: '+32', BM: '+1', BT: '+975',
  BO: '+591', BA: '+387', BW: '+267', BR: '+55', VG: '+1', BN: '+673',
  BG: '+359', KH: '+855', CA: '+1', IC: '+34', KY: '+1', CL: '+56',
  CN: '+86', CC: '+61', CO: '+57', KM: '+269', CR: '+506', HR: '+385',
  CY: '+357', CZ: '+420', DK: '+45', DM: '+1', DO: '+1', EC: '+593',
  EG: '+20', EE: '+372', FO: '+298', FJ: '+679', FI: '+358', FR: '+33',
  GF: '+594', PF: '+689', GA: '+241', GE: '+995', DE: '+49', GH: '+233',
  GI: '+350', GR: '+30', GL: '+299', GD: '+1', GP: '+590', GT: '+502',
  GG: '+44', HN: '+504', HK: '+852', HU: '+36', IS: '+354', IN: '+91',
  ID: '+62', IE: '+353', IM: '+44', IL: '+972', IT: '+39', JM: '+1',
  JP: '+81', JE: '+44', JO: '+962', KZ: '+7', KE: '+254', XK: '+383',
  KW: '+965', LV: '+371', LB: '+961', LI: '+423', LT: '+370', LU: '+352',
  MO: '+853', MY: '+60', MV: '+960', MT: '+356', MQ: '+596', MU: '+230',
  EA: '+34', MX: '+52', MD: '+373', MC: '+377', ME: '+382', MA: '+212',
  NP: '+977', NL: '+31', NC: '+687', NZ: '+64', NI: '+505', MK: '+389',
  'GB-NIR': '+44', NO: '+47', OM: '+968', PW: '+680', PA: '+507', PG: '+675',
  PE: '+51', PH: '+63', PL: '+48', PT: '+351', PR: '+1', QA: '+974',
  RE: '+262', RO: '+40', SA: '+966', SN: '+221', RS: '+381', SC: '+248',
  SL: '+232', SG: '+65', SK: '+421', SI: '+386', ZA: '+27', KR: '+82',
  ES: '+34', BL: '+590', KN: '+1', SE: '+46', CH: '+41', TW: '+886',
  TH: '+66', TT: '+1', TN: '+216', TR: '+90', TV: '+688', VI: '+1',
  AE: '+971', GB: '+44', US: '+1', UY: '+598', UZ: '+998', VE: '+58',
  VN: '+84', YE: '+967',
};
